<mat-icon class="info-icon" *ngIf="label" [matTooltip]="label | striphtml" #tooltip="matTooltip" matTooltipPosition="below">info</mat-icon>

<!-- <div class="info-content" [class.open]="open">
  <ng-content></ng-content>
</div> -->